import "./polyfills";
import React from "react";
import { createRoot } from 'react-dom/client';

import { HashRouter } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import "./assets/base.scss";
import AppRoot from "./AppRoot";
import configureAppStore from "./config/configureStore";
import { Provider } from "react-redux";
import * as serviceWorkerRegistration from "./serviceWorker";

const store = configureAppStore();
const rootElement = document.getElementById("root");

const renderApp = (Component) => (
  <React.StrictMode>
    <Provider store={store}>
      <HashRouter
        future={{
          v7_startTransition: true,
          v7_relativeSplatPath: true
        }}
      >
        <Component />
      </HashRouter>
    </Provider>
  </React.StrictMode>
);

const root = createRoot(rootElement);
root.render(renderApp(AppRoot));
serviceWorkerRegistration.register();

// Vite HMR
if (import.meta.hot) {
  import.meta.hot.accept("./AppRoot", (newModule) => {
    if (newModule) {
      root.render(renderApp(newModule.default));
    }
  });
}
